// The tilelytics API application coordinates already registered in a B2C tenant.
export const apiConfig = {
  b2cScopes: [process.env.VUE_APP_B2C_TILELYTICS_UI_API_SCOPE],
};
